/**
 * Merges the current URL's query params into a destination path so inbound marketing
 * params (utm_*, gclid, ...) survive hard redirects. Params already declared on the
 * destination take precedence over inbound ones.
 */
export const withCurrentQueryParams = (destination: string, search: string = window.location.search): string => {
  const inbound = (search || '').replace(/^\?/, '');
  if (!inbound) return destination;

  const [path, destinationSearch = ''] = destination.split('?');
  const merged = new URLSearchParams(inbound);
  new URLSearchParams(destinationSearch).forEach((value, key) => merged.set(key, value));

  const query = merged.toString();
  return query ? `${path}?${query}` : path;
};
